import Image from 'next/image';
import Link from 'next/link';
import { cn } from '@/lib/utils';

export function Logo(props: { className?: string; link?: string }) {
  return (
    <Link href={props.link ?? '/'} className={cn('items-center space-x-2', props.className)}>
      <Image
        src="/logo.svg"
        alt="OpsVis.ai"
        width={140}
        height={35}
        className="h-9 w-auto md:h-10"
        priority
      />
    </Link>
  );
}
